/* eslint-disable import/no-unresolved */
// swiper bundle styles
import "swiper/swiper-bundle.min.css";

// swiper core styles
import "swiper/swiper.min.css";

// eslint-disable-next-line import/extensions
import "swiper/css/navigation";

// eslint-disable-next-line import/extensions
import "swiper/css/pagination";

import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import useFacebookPixel from "hooks/FacebookPixel/useFacebookPixel";
import Swipercore, { Navigation, Pagination, Autoplay } from "swiper";

import BannerSection from "./components/Banner/Banner";
import RecommendedVehiclesSection from "./components/RecommendedVehicles/RecommendedVehicles";
import AlliesSection from "./components/Allies/Allies";
import FinancingStepsSection from "./components/FinancingSteps/FinancingSteps";
import CreditPaymentSection from "./components/CreditPayment/CreditPayment";
import FinancialInclusionSection from "./components/FinancialInclusion/FinancialInclusion";
import BrandsSection from "./components/Brands/Brands";
import TestimonialsSection from "./components/Testimonials/Testimonials";
import HeadquartersSection from "./components/Headquarters/Headquarters";
import BenefitsSection from "./components/Benefits/Benefits";
import CTAsSection from "./components/CTAs/CTAs";


const HomeScreen: React.FC = () => {
  Swipercore.use([Navigation, Pagination, Autoplay]);
  const pixelLib = useFacebookPixel();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/" });
    pixelLib.pageView();
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <BannerSection />
      <RecommendedVehiclesSection />
      <AlliesSection />
      <FinancingStepsSection />
      <CreditPaymentSection />
      <FinancialInclusionSection />
      <BrandsSection />
      <TestimonialsSection />
      <HeadquartersSection />
      <BenefitsSection />
      <CTAsSection />
    </>
  );
};

export default HomeScreen;
